import gql from 'graphql-tag';

export default gql`
	mutation SingleUpload($file: Upload, $path: String) {
		singleUpload(file: $file, path: $path) {
			path
		}
	}
`;
